import { useState } from "react";
import './Styles.css';

export interface InputProps {
    value: string | number;
    placeHolder: string;
    onChange: (val: string) => void;
    name?: string;
    invalid?: boolean;
    errorText?: string;
    blueShadow?: boolean;
    type?: string;
    autoComplete?: string;
}

export const Input: React.FC<InputProps> = ({type = "string", ...props}) => {

    const handleInputChange = (val: string) => {
        props.onChange(val);
    }

    return (
        <div>
            <div className="w-full box-border shadow-main rounded-xl">
            <input
                type={type}
                spellCheck={false}
                name={props.name ? props.name : ""}
                placeholder={props.placeHolder}
                autoComplete={props.autoComplete}
                value={props.value}
                onChange={(e) => handleInputChange(e.target.value)}
                className={`w-full ${props.invalid ? "border-red-500 border-[1px]" : ""} shadow-main border-gray-100 rounded-xl px-3 py-2 custom-input ${props.blueShadow ? 'focus:outline-primary focus:outline-[5px]' : ''}`}
                style={{
                    outline: "none",
                  }}
            />
        </div>
        {
                props.invalid && props.errorText &&
                <div className="text-red-500 mt-[-4px] text-sm text-start pt-1">{props.errorText}</div>
            }
        </div>
        
    )
}